import { render, staticRenderFns } from "./EditUserRegions.vue?vue&type=template&id=0bd471a5&scoped=true"
import script from "./EditUserRegions.vue?vue&type=script&lang=js"
export * from "./EditUserRegions.vue?vue&type=script&lang=js"
import style0 from "./EditUserRegions.vue?vue&type=style&index=0&id=0bd471a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd471a5",
  null
  
)

export default component.exports